import 'application/src/scss/landingpage/product/desinfectant.scss';

import * as basicLightbox from 'basiclightbox';
import { Mediator, SpinnerOverlay } from 'application/src/js/util.js';
import OffersAndRequests from './offers-and-requests/main.js';
import NewsList from './news/main.js';
import Companies from './companies/main.js';

window.addEventListener('DOMContentLoaded', _ => {

  // lightbox
  [...document.querySelectorAll('.lightbox')].map(element => {
    const instance = basicLightbox.create(`<img src="${element.src}" alt="">`);
    element.addEventListener('click', e => instance.show());
  });

  const loader = new SpinnerOverlay({
    targetContainer: document.querySelector('.lp-content'),
    position: 'fixed',
    visible: true
  });

  const mediator = new Mediator();

  // ensures that the loader shows when the first request
  // is fired and hides after ALL requests completed
  let runningLoadingProcesses = 0;
  mediator.subscribe('startedLoading', _ => {
    runningLoadingProcesses++;
    if (runningLoadingProcesses === 1) loader.show();
  });
  mediator.subscribe('finishedLoading', _ => {
    runningLoadingProcesses--;
    if (runningLoadingProcesses === 0) loader.hide();
  });

  new OffersAndRequests({
    basicIds: basicIds,
    loader: loader,
    translations: {
      offers: translations.landingpage.offers,
      requests: translations.landingpage.requests
    },
    mediator: mediator
  });

  new NewsList({
    basicIds: basicIds,
    loader: loader,
    translations: translations.landingpage.news,
    mediator: mediator
  });

  new Companies({
    basicIds: basicIds,
    loader: loader,
    translations: translations.landingpage.addresses,
    mediator: mediator
  });
});